<template>
  <div :class="[{root: true, sidebarClose, sidebarStatic}, 'sing-dashboard']">
    <Sidebar/>
    <!-- <Helper />-->
    <div class="wrap">
      <Header/>
      <v-touch class="content" @swipe="handleSwipe" :swipe-options="{direction: 'horizontal'}">
        <breadcrumb-history></breadcrumb-history>
        <transition name="router-animation">
          <router-view/>
        </transition>
        <footer class="contentFooter">
          Ekhoni Daktar - Made by <a href="https://innovabd.tech" rel="nofollow noopener noreferrer" target="_blank">Innova
          Tech</a>
        </footer>
      </v-touch>
    </div>
    <b-modal v-model="showCallDialog"
             centered title="Incoming Call"
             no-close-on-backdrop no-close-on-esc
    >
      <template v-slot:default="">
        <p>Incoming Call from Patient</p>
      </template>
      <template v-slot:modal-footer="{}">
        <!-- Emulate built in modal footer ok and cancel button actions -->
        <b-button size="sm" variant="success" @click="moveToCallPage">
          Accept
        </b-button>

        <b-button size="sm" variant="danger" @click="abortCall(3)">
          Cancel
        </b-button>
        <!-- Button with custom close trigger value -->

      </template>
    </b-modal>

  </div>
</template>

<script>
import {mapState, mapGetters, mapActions} from 'vuex';

import Sidebar from '@/components/doctor/Sidebar/Sidebar';
import Header from '@/components/doctor/Header/Header';
import BreadcrumbHistory from '@/components/doctor/BreadcrumbHistory/BreadcrumbHistory';

import './DoctorLayout.scss';
import CheckupService from '@/services/checkup.service';
import DoctorService from "@/services/general_user/doctor.service";
// const ringtone = new Audio('@/assets/sounds/ringtone.wav');

export default {
  name: 'DoctorLayout',
  components: {Sidebar, Header, BreadcrumbHistory},
  data() {
    return {
      showCallDialog: false,
    }
  },
  methods: {
    ...mapActions('doctorCheckup', ['initializeFirebaseListener', 'setCallInfo']),
    ...mapActions('doctorLayout', ['setdoctortype', 'switchSidebar', 'handleSwipe', 'changeSidebarActive', 'toggleSidebar']),
    fetchDoctorTypes() {
      DoctorService.fetchDoctorTypes()
          .then((response) => {
            if (response.status === 200) {
              this.setdoctortype(response.data);
            }
          })
    },
    handleWindowResize() {
      const width = window.innerWidth;

      if (width <= 768 && this.sidebarStatic) {
        this.toggleSidebar();
        this.changeSidebarActive(null);
      }
    },

    moveToCallPage() {

      let routeData = this.$router.resolve({
        name: 'doctorCheckup',
        params: {patientcheckup_code: this.getCallInfo.checkup_code}
      });
      window.open(routeData.href, '_blank', 'location=yes,channelmode=yes,fullscreen=yes,scrollbars=yes,status=yes');
      this.showCallDialog = false;
    },

    abortCall(status) {
      CheckupService.terminateCall(status)
          .then((response) => {
            if (response.status === 204) {
              this.setCallInfo(null)
            }
          })
          .catch((e) => console.error(e));
      this.showCallDialog = false;

    }
  },
  computed: {
    ...mapState('doctorLayout', ["sidebarClose", "sidebarStatic"]),
    ...mapGetters('doctorAuth', ['getUser']),
    ...mapGetters('doctorCheckup', ['isCallIncoming', 'getCallInfo']),
  },
  watch: {
    isCallIncoming: function (newVal) {
      this.showCallDialog = !!newVal;
    }
  },
  created() {
    const staticSidebar = JSON.parse(localStorage.getItem('sidebarStatic'));

    if (staticSidebar) {
      this.$store.state.doctorLayout.sidebarStatic = true;
    } else if (!this.sidebarClose) {
      setTimeout(() => {
        this.switchSidebar(true);
        this.changeSidebarActive(null);
      }, 2500);
    }

    this.handleWindowResize();
    window.addEventListener('resize', this.handleWindowResize);
  },
  mounted() {
    this.fetchDoctorTypes();
    // this.initializeFirebaseListener(this.getUser.code);
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.handleWindowResize);
  }
};
</script>

<style src="./DoctorLayout.scss" lang="scss"/>
